module.exports = __webpack_public_path__ + "img/lead-07e.a3ff2f61.png";